<template>
  <div class="articles">
    <ArticlePreview
      v-for="article in articles"
      :key="article.id || article.slug"
      :image="article.image"
      :slug="article.slug"
      :theme="article.theme"
      :category="article.category"
      :title="article.title"
      :niche="article.filter_niche?.name"
      :date="article.date"
      :description="article.short_description || article.description || ''"
    />
  </div>
</template>

<script>
import ArticlePreview from "~/components/molecules/ArticlePreview.vue";

export default {
  components: {ArticlePreview},
  props: {
    articles: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">
.articles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 32px 22px;
  width: 100%;

  @include medium {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @include tablets {
    gap: 32px 11px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @include small-tablets {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 32px 11px;
    margin-left: -16px;
    margin-right: -16px;
    width: calc(100% + 32px);
  }

  @include mobile {
    gap: 32px 11px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-left: -16px;
    margin-right: -16px;
    width: calc(100% + 32px);
  }
}
</style>
